/*global prodcat*/
(function(site, $) {
  var formCaptureObj = {}, linkCaptureObj = {};
  var drupalAltImgSettings = Drupal.settings.analytics ? Drupal.settings.analytics.alt_image_tagging_enabled : false;
  // Flag to avoid bubbling on alt image click
  var altImageClickCheck = false;
  // Flag to check shade select
  var shadeClickCheck = false;
  // Flag to check shade/size change
  var sizeChangeCheck = false;

  Drupal.behaviors.analyticsBehavior = {

    attached: 0,

    linkToPage: function() {
      window.open(linkCaptureObj.href, linkCaptureObj.target);
    },

    setLinkCapture: function(href, target) {
      linkCaptureObj.href = href;
      linkCaptureObj.target = target;
    },

    submitForm: function() {
      formCaptureObj.form.off('submit');
      formCaptureObj.form.trigger('submit');
    },

    stripOutMarkup: function(str) {
      return str.replace(/(<([^>]+)>)/ig, '');
    },

    // Accepts an array of PRODUCT_IDS, returns an array of positions
    getProductPositions: function(productIds) {
      var positions = [];
      var i;
      var j = productIds.length;
      if (window.hasOwnProperty('prodcat') && prodcat.hasOwnProperty('data') && prodcat.data.hasOwnProperty('pids')) {
        for (i = 0; i < j; i++) {
          positions.push(this.findElementIndex(prodcat.data.pids, productIds[i]));
        }
      }
      return positions;
    },

    // Examples of brand specific overrides for event handling

    addToCart: function(eventData) {
      site.track.addToCart(Object.assign({}, eventData));
    },

    addToFavorites: function(eventData) {
      site.track.addToFavorites(Object.assign({}, eventData));
    },

    removeFromCart: function(eventData) {
      site.track.removeFromCart(Object.assign({}, eventData));
    },

    // End examples brand specific overrides for event handling

    attach: function(context) {
      // all code here
      var self = this;
      var eventObj = {};
      if (self.attached) {
        return;
      }

      // Track Brand Logo
      $('.js-brand-logo-link', context).on('click', function(event) {
        var obj;
        event.preventDefault();
        self.setLinkCapture($(this).attr('href'), '_self');
        obj = {
          event_name: 'logo_click',
          event_category: 'global',
          event_action: 'logo clicked'
        };
        site.track.evtLink(obj, self.linkToPage);
      });
      // Track Product Click
      var productClickElement = [
        '.product_brief__image-container',
        '.product_brief__headers',
        '.product_brief__full-details',
        '.product_brief__buttons',
        '.product-brief__button-quickshop',
        '.product-brief a:first-child'
      ];

      $(document).on('click', productClickElement.join(', '), function () {

        var $this = $(this);
        // don't track shade clicks

        if ($this.hasClass('swatch')) {
          return;
        }
        var prodElem = $this.closest('.js-product-brief, .product-brief');
        var prodId = prodElem.attr('data-product-id');

        if (typeof prodId !== 'undefined' && prodId !== '') {
          site.track.productClick({
            targetElem: $this,
            product_id: [prodId]
          });
        }
      });

      // Product click on Recommendation section
      $('.recommended-product-items .recommended-item').each(function (index) {
        $(this).attr('data-index', index);
      });

      recomProductSelectors = [
        '.recommended-item a.thumb',
        '.recommended-item .product_name a',
        '.recommended-item .produce_subname a'
      ];
      $(document).on('click', recomProductSelectors.join(', '), function () {
        var $prodElem = $(this);
        var prodId = $prodElem.closest('.recommended-item').find('.js-quickshop').data('product-id');
        if (typeof prodId == 'undefined') {
          var $prodHref = $prodElem.attr('href');
          var splitprod = $prodHref.split('/');
          var prodId = 'PROD' + splitprod[5];
        }
        var prodPosition = Number($prodElem.closest('.recommended-item').data('index')) + 1;
        var prodName = $prodElem.closest('.recommended-item').find('.produce_subname').text().trim();
        if (typeof prodId !== 'undefined' && prodId !== '') {
          site.track.productClick({
            targetElem: $prodElem,
            product_id: [prodId],
            product_position: [prodPosition],
            product_impression_name: [prodName]
          });
        }
      });

      //track Navigation Click
      $('.js-nav-link-trigger', context).on('click', function() {
        var navElemLast = $(this).text();
        var parentElem = $(this).parent();
        var promoName = [];
        var navTrackName = $(this).closest('.node').attr('trackname').split('|', 1);
        promoName.push(navTrackName[0].split(' - ')[1]);
        if (!parentElem.hasClass('menu__item--category')) {
          var navCategoryElem = parentElem.prevAll('.menu__item--category:first').find('.js-nav-link-trigger');
          if (navCategoryElem.length > 0) {
            promoName.push(navCategoryElem.text());
          }
        }
        promoName.push(navElemLast);
        if (promoName.length > 0) {
          site.track.navigationClick({
            promo_name: [promoName.join('>')]
          });
        }
      });

      $('.menu-ref__link', context).on('click', function() {
        var promoName = $(this).text();
        if (typeof promoName !== 'undefined' && promoName !== '') {
          site.track.navigationClick({
            promo_name: [promoName]
          });
        }
      });

      // Track Quick Shop
      var productDetailElement = [
        'a.js-mpp_quickshop',
        '.product_brief__button-panel',
        '.js-quickshop-show',
        '.product-brief a:first-child',
        '.discover_more__product-quickshop'
      ];
      $(document).on('click', productDetailElement.join(', '), function(event) {
        var position = 0;
        var catName = $('.main-content > article', context).attr('trackname');
        var prodElem = $(this).closest('.js-product-brief,.product-brief,.discover_more__product');
        var prodId = $(this).attr('data-product-id') || $(this).attr('data-productid') || $(this).closest('.js-product-brief').attr('data-product-id');
        var prodHeader = prodElem.find('.product_brief__header,.product-brief__header,.discover_more__product-header').text();
        var prodSubHeader = prodElem.find('.product_brief__sub-header,.product-brief__sub-header,.discover_more__product-sub-header').text();
        var prodName = prodHeader + ' ' + prodSubHeader;
        if (window.hasOwnProperty('prodcat') && prodcat.hasOwnProperty('data') && prodcat.data.hasOwnProperty('pids')) {
          position = self.getProductPositions([prodId]);
        }
        var obj = {
          event_label: prodName + ' - ' + prodId,
          page_name: 'QV | ' + prodName,
          product_id: [prodId],
          product_catagory_name: [catName],
          product_price: [prodElem.find('.product_brief__price,.product-brief__price').text().replace(/\s+/g, ' ').trim()],
          product_position: position
        };

        if ($(event.target).hasClass('js-analytics-quickshop-home') || $(event.target).hasClass('js-quickshop-show') || $(event.target).hasClass('product_brief__button-panel') || $(event.target).hasClass('js-mpp_quickshop') || $(event.target).hasClass('discover_more__product-quickshop')) {
          site.track.quickView(obj);
        }

      });

      //Track Quick Shop 2 - Special case in EL where some pages don't have data-test-id=mpp_quickshop
      $(document).on('click', '.js-quickshop', function() {
        var position = 0;
        var catName = $('.main-content > article', context).attr('trackname');
        var prodElem = $(this).parent().siblings('.description');
        var prodId = $(this).attr('data-product-id');
        var prodName = prodElem.children().find('.product_name').text().trim();
        if (window.hasOwnProperty('prodcat') && prodcat.hasOwnProperty('data') && prodcat.data.hasOwnProperty('pids')) {
          position = self.getProductPositions([prodId]);
        }
        var obj = {
          event_label: prodName + ' - ' + $(this).attr('data-product-id'),
          page_name: 'QV | ' + prodName,
          product_id: [prodId],
          product_catagory_name: [catName],
          product_price: prodElem.children().find('.formatted_price').text().trim(),
          product_position: position
        };
        site.track.quickView(obj);
      });

      //Track Product Click
      var productClickElement = [
        '.discover_more__product-quickshop',
      ];
      $(document).on('click', productClickElement.join(', '), function() {
        var $this = $(this);
        //don't track shade clicks 
        if ($this.hasClass('swatch')) {
          return;
        }
        var prodElem = $this.closest('.js-product-brief, .product-brief, .js-discover-more-quickshop');
        var prodId = prodElem.attr('data-product-id') || prodElem.attr('data-productid');

        if (typeof prodId !== 'undefined' && prodId !== '') {
          site.track.productClick({
            targetElem: $this,
            product_id: [prodId]
          });
        }
      });

      // Track Predictive Search Product Click and All Results Click
      /*$('#typeahead-wrapper').on('click', '.product-result', function() {
        var prods = $(this);
        var prodName = prods.find('.product-result__name a').text().trim();
        var prodElemID = 'PROD' + prods.find('.product-result__name a').attr('href').split('/')[3];
        var term = $('input#search').val();
        var obj;
        event.preventDefault();
        self.setLinkCapture($(this).attr('href'), '_self');
        obj = {
          event_label: term,
          search_keyword: term,
          product_id: prodElemID,
          product_name: prodName
        };
        site.track.evtAction('searchOneResultSelected', obj, self.linkToPage);
      });*/

      // CHECKOUT EVENTS

      // Track guest user checkout
      $('#checkout_signin_guest_user,#checkout_signin_new_user').on('submit', function() {
        var obj = {};
        site.track.evtAction('checkoutGuestUser', obj);
      });

      // Track return user checkout
      $('#checkout_signin').on('submit', function() {
        var obj = {};
        site.track.evtAction('checkoutReturnUser', obj);
      });

      // Track payment details
      $(document).on('checkout:panel:displayed', function() {
        $('#checkout_billing input.btn-primary,#checkout_review input.button--dark').on('click', function() {
          var payment_label = '';
          var payment_type = $('input[name=PAYMENT_METHOD]:checked').val() || $('input[name=PAYMENT_TYPE]:checked').val();
          if (payment_type === 'PP' || payment_type === 'PayPal') {
            payment_label = 'paypal';
          } else if (payment_type === 'CC' || payment_type === 'Credit Card') {
            payment_label = 'creditcard';
          }
          var obj = {
            event_label: payment_label
          };
          site.track.evtAction('checkoutPaymentSelected', obj);
        });
      });

      // Track Paypal Express Check-out
      $('a.paypal-checkout').on('click', function() {
        var obj = {
          event_label: 'paypal'
        };
        site.track.evtAction('checkoutPaymentSelected', obj);
      });

      // END CHECKOUT EVENTS

      // Alt image tracking start
      if ($('body').hasClass('section-product') && drupalAltImgSettings) {
        // Disable alt image tagging while selecting shades
        $(document).on('click', '.swatches--single', function() {
          shadeClickCheck = true;
        });
        // Disable alt image tagging while chaging shades or size
        $(document).on('change', '.js-sku-menu', function() {
          sizeChangeCheck = true;
        });
        // Trigger Alt image event only when alternate images are available
        if ($('body').hasClass('device-pc') && $('.product-full__images .slick-dots li').length > 1) {
          trackAltImageTrackingClickPC();
          trackAltImageTrackingDragPC();
        } else if ($('body').hasClass('device-mobile')) {
          trackAltImageTrackingMobile();
        }
      }

      // Track Alt image click - desktop
      function trackAltImageTrackingClickPC() {
        $(document).on('click', '.js-product-image-thumb', function() {
          altImageClickCheck = true;
          var $targetElem = $(this);
          var altImageName = '';
          var prodDetails = buildAltImageProductName($targetElem);
          var bgImageUrl = $targetElem.css('background-image');
          var altImageUrl = bgImageUrl.replace('url(', '').replace(')', '').replace(/\"/gi, '');
          if (altImageUrl.length) {
            altImageName = buildAltImageFileName(altImageUrl);
          }
          trackThumbnailClickEvent(altImageName, prodDetails[0], prodDetails[1], 'click');
        });
      }

      // Track Alt image drag - desktop
      function trackAltImageTrackingDragPC() {
        $(document).on('afterChange', '.product-full__images', function() {
          if (!altImageClickCheck && !shadeClickCheck && !sizeChangeCheck) {
            var $targetElem = $(this);
            var altImageName = '';
            var prodDetails = buildAltImageProductName($targetElem);
            var bgImageUrl = $targetElem.find('.slick-current img').attr('src');
            if (bgImageUrl) {
              altImageName = buildAltImageFileName(bgImageUrl);
            }
            trackThumbnailClickEvent(altImageName, prodDetails[0], prodDetails[1], 'drag');
          }
          altImageClickCheck = false;
          shadeClickCheck = false;
          sizeChangeCheck = false;
        });
      }

      // Track Alt image swipe - Mobile
      function trackAltImageTrackingMobile() {
        $(document).on('afterChange', '.spp-product__images', function() {
          var $targetElem = $(this);
          var altImageName = '';
          var prodDetails = buildAltImageProductName($targetElem);
          var bgImageUrl = $targetElem.find('.slick-current img').attr('src');
          if (bgImageUrl) {
            altImageName = buildAltImageFileName(bgImageUrl);
          }
          trackThumbnailClickEvent(altImageName, prodDetails[0], prodDetails[1], 'swipe');
        });
      }

      // Build Alt image product name
      function buildAltImageProductName(targetElem) {
        var prodElem = targetElem.closest('.js-pr-product');
        var prodId = prodElem.attr('data-product-id');
        var prodHeader = prodElem.find('.product-full__title, .spp-product__header').text();
        var prodSubHeader = prodElem.find('.product-full__subtitle, .spp-product__sub-header').text();
        var prodName = prodHeader + ' ' + prodSubHeader;
        return [prodName, prodId];
      }

      // Build Alt image file name
      function buildAltImageFileName(altImageUrl) {
        var altImageArray = altImageUrl.split('/');
        var altImageName = altImageArray[altImageArray.length - 1].split('.')[0];
        return altImageName;
      }

      // Track product thumbnail click event
      function trackThumbnailClickEvent(altImageName, prodName, prodId, eventType) {
        var obj = {
          'event_action': 'alt image - ' + altImageName + ' - ' + eventType,
          'event_label': prodName + ' - ' + prodId
        };
        site.track.productThumbnailClick(obj);
      }
      // Alt image tracking end

      //Moisturizer Quiz Tagging start
      var $moisturizerQuiz = $('body').find('.moisturizer-repromote-quiz');
      if ($('body').hasClass('section-skin-care') || $('body').hasClass('section-moisturisers') || $moisturizerQuiz.length) {
        trackMoisturizerTagging();
      }

      function trackMoisturizerTagging() {
        $('.js-quiz-question', context).each(function(key) {
          $(this).attr('data-id', key);
        });

        var quizStep;
        initMoisturizerTagging();

        function trackQuizStartTagging() {
          $(document).on('click', '.js-btn-init-quiz', function() {
            trackEvent('diagtools', 'diagnostic tool - moisturizer quiz', 'start button', 'click');
            trackNextPage('/skin-care/moisturizer/step1', '/skin-care/moisturizer/step1', 'Skin-care/Moisturizer - Step 1');
          });
        }

        function trackQuiztagging() {
          $('.js-panel-quiz .js-btn-next', context).once('js-Quiz-tagging').each(function() {
            var $quizElem = $(this);
            $quizElem.on('click', function() {
              var $quizParentElem = $quizElem.closest('.js-panel-quiz');
              var quiztitle = $quizParentElem.find('.mr-question--current .mr-question__question').text().trim();
              var quizval = $quizParentElem.find('.mr-question--current .mr-question__option--selected').text();
              var eventLabel = quiztitle + ' - ' + quizval;
              quizStep = $quizParentElem.find('.mr-question--current').data('id');
              if (quizval) {
                trackEvent('diagtools', 'diagnostic tool - moisturizer quiz', 'questions', eventLabel);
                if ($quizElem.text().trim() !== 'Show Results') {
                  trackNextPage('/skin-care/moisturizer/step' + (quizStep + 2), '/skin-care/moisturizer/step' + (quizStep + 2), 'Skin-care/Moisturizer - Step ' + (quizStep + 2));
                }
              }
            });
          });
        }

        function trackQuizBackTagging() {
          $('.mr-actions__back', context).once('js-quiz-back').each(function() {
            var $quizBackElem = $(this);
            $quizBackElem.on('click', function() {
              var backStep = $('.js-btn-back').closest('.js-panel-quiz').find('.mr-question--current').data('id');
              trackEvent('diagtools', 'diagnostic tool - moisturizer quiz', 'back button', 'click');
              trackNextPage('/skin-care/moisturizer/step' + backStep, '/skin-care/moisturizer/step' + backStep, 'Skin-care/Moisturizer - Step ' + backStep);
            });
          });
        }

        function trackQuizRestartTagging() {
          $('.js-btn-restart', context).once('js-quiz-restart').each(function() {
            var $quizRestartElem = $(this);
            $quizRestartElem.on('click', function() {
              trackEvent('diagtools', 'diagnostic tool - moisturizer quiz', 'start over', 'click');
            });
          });
        }

        function trackOverlayClose() {
          $(document).on('click', '.mr-results .js-btn-close-results', function() {
            var currentStep = $('.js-btn-back').closest('.js-panel-quiz').find('.mr-question--current').data('id');
            trackEvent('diagtools', 'diagnostic tool - moisturizer quiz', 'overlay', 'closed');
            trackNextPage('/skin-care/moisturizer/step' + (currentStep + 1), '/skin-care/moisturizer/step' + (currentStep + 1), 'Skin-care/Moisturizer - Step ' + (currentStep + 1));
          });
        }

        function tracktestTagging() {
          $(document).on('Quizresult', function() {
            var $resultItems = $('.js-panel-results');
            var productImpressionIds = [];
            var productPositions = [];
            var productImpressionList = [];
            var $elem;
            $resultItems.find('.mr-quiz-result-v1').each(function(index, elem) {
              if (!$(elem).hasClass('slick-cloned')) {
                if (!$(elem).length) {
                  return;
                }
                $elem = $(elem);
                productImpressionIds.push($elem.attr('data-product-val'));
                productPositions.push(($elem.attr('data-slick-index') * 1) + 1);
                productImpressionList.push(location.pathname + '/results');
              }
            });

            var objView = {
              product_impression_list: productImpressionList,
              product_impression_position: productPositions,
              product_impression_id: productImpressionIds,
              location: location.origin + location.pathname + '/results',
              page_url: '/skin-care/moisturizer/results',
              page_name: 'Skin-care/Moisturizer - Results'
            };
            site.track.evtView(objView);
          });
        }

        function trackProductResult() {
          $(document).on('click', '.mr-result__cta', function() {
            var prodElem = $(this).closest('.mr-quiz-result-v1.slick-active');
            var productId = prodElem.attr('data-product-val');
            var productPosition = prodElem.attr('menu-order');
            var eventObj = {};
            eventObj.enh_action = 'product_click';
            eventObj.product_position = [productPosition];
            eventObj.product_id = [productId];
            eventObj.product_list = [location.pathname + '/results'],
            trackEvent('diagtools', 'ecommerce', 'product click', 'product click', eventObj);
          });
        }

        function trackNextPage(pageurl, plocation, pname) {
          var objView = {};
          Object.assign(objView, {
            page_url: pageurl,
            location: location.origin + plocation,
            page_name: pname
          });
          site.track.evtView(objView);
          objView = {};
        }

        function initMoisturizerTagging() {
          trackQuizStartTagging();
          trackQuiztagging();
          trackQuizBackTagging();
          trackQuizRestartTagging();
          trackProductResult();
          trackOverlayClose();
          trackNextPage();
          tracktestTagging();
        }
      }
      //Moisturizer Quiz Tagging end.

      // Skincare Diagnostic Quiz Tagging start.
      if ($('body').hasClass('section-skincare-quiz')) {
        trackSkinDiagnosticTagging();
      }

      function trackSkinDiagnosticTagging() {
        initSkinDiagnosticTagging();

        function foundationstartTagging() {
          $(document).on('SkincareNext', function(event, data) {
            var stepCount = $('.js-mantle-cta-button').closest('.js-form-formatter__item.active').data('field-order') + 1;
            var quizQuestion = $('.js-mantle-cta-button').closest('.js-form-formatter__item.active').data('field-name');
            var quizAnswerLength = $('.js-form-formatter__item.active').find('.has-selected-value').length;
            var quizAnswer = '';
            $('.js-mantle-cta-button').closest('.js-form-formatter__item.active').find('.js-mantle-form__checkbox.active .js-adpl-active').each(function(index, elem) {
              var quizName = $(this).attr('placeholder');
              quizAnswer += quizName + ',';
            });
            var quizSlice = quizAnswer.slice(-1);
            if (quizSlice === ',') {
              quizAnswer = quizAnswer.slice(0, -1);
            }
            var eventLabel = quizQuestion + ' - ' + quizAnswer;
            if (stepCount === 1) {
              trackEvent('diagtools', 'diagnostic tool - skin quiz', 'start button', 'click');
              trackNextPage('/skincare-quiz/step' + stepCount, '/step_' + stepCount, 'skincare-quiz - Step ' + stepCount);
            } else if (quizAnswer && quizAnswerLength === 1) {
              trackEvent('diagtools', 'diagnostic tool - skin quiz', 'questions', eventLabel);
            }
            if (stepCount !== 1 && (stepCount !== 4 && quizAnswer || quizAnswerLength === 0)) {
              trackNextPage('/skincare-quiz/step' + stepCount, '/step_' + stepCount, 'skincare-quiz - Step ' + stepCount);
            }
          });
        }

        function trackNavTagging() {
          $(document).on('click', '.js-form-indicator-menu .js-form-indicator.active', function() {
            var stepCount = $(this).closest('.js-form-formatter').data('current-step');
            trackNextPage('/skincare-quiz/step' + stepCount, '/step_' + stepCount, 'skincare-quiz - Step ' + stepCount);
          });
        }

        function trackBackButton() {
          $(document).on('SkincareBack', function(event, data) {
            var currentStep = data.new_order;
            trackEvent('diagtools', 'diagnostic tool - skin quiz', 'back button', 'click');
            trackNextPage('/skincare-quiz/step' + currentStep, '/step_' + currentStep, 'skincare-quiz - Step ' + currentStep);
          });
        }

        function resultPageTagging() {
          $(document).on('filterResult', function(event, data) {
            var $menuItems = $(data.html);
            var productImpressionIds = [];
            var productPositions = [];
            var productImpressionList = [];
            var $elem;
            $menuItems.find('.skin-finder-results__product-wrapper .js-product-brief').each(function(index, elem) {
              if (!$(elem).length) {
                return;
              }
              $elem = $(elem);
              productImpressionIds.push($elem.attr('data-product-id'));
              productPositions.push(index + 1);
              productImpressionList.push(location.pathname + '/results');
            });

            var objView = {
              product_impression_list: productImpressionList,
              product_impression_position: productPositions,
              product_impression_id: productImpressionIds,
              location: location.origin + location.pathname + '/results',
              page_url: '/skincare-quiz/results',
              page_name: 'skincare-quiz - results'
            };
            site.track.evtView(objView);
            objView = {};
          });
        }

        function trackRequiz() {
          $(document).on('click', '.js-quiz-page-formatter__results-footer, .js-launch-account--return', function() {
            var eventLable = $(this).text().trim();
            trackEvent('diagtools', 'diagnostic tool - Skin quiz', eventLable, 'Click');
            if ($(this).hasClass('js-quiz-page-formatter__results-footer')) {
              trackNextPage('/skincare-quiz/step1', '/skincare-quiz/step1', 'skincare-quiz - Step 1');
            }
          });
        }

        function trackProductClick() {
          $(document).on('click', '.js-pr-product .product-brief__image, .product-brief__headers', function() {
            var quizProductId = $(this).data('product-id') || $(this).closest('.js-product-brief').data('product-id');
            var quiztPosition = $(this).closest('.js-product').data('slick-index') + 1;
            var eventObj = {};
            eventObj.enh_action = 'product_click';
            eventObj.product_position = [quiztPosition];
            eventObj.product_list = [location.pathname + '/results'];
            eventObj.product_id = [quizProductId];
            trackEvent('diagtools', 'ecommerce', 'product click', 'product click', eventObj);
          });
        }

        function trackQuickShop() {
          $(document).on('click', 'span.quickshop__add-button', function() {
            var quizProductId = $(this).data('product-id');
            var quiztPosition = $(this).closest('.js-product').data('slick-index') + 1;
            var eventObj = {};
            eventObj.enh_action = 'product_click';
            eventObj.product_position = [quiztPosition];
            eventObj.product_list = [location.pathname + '/results'];
            eventObj.product_id = [quizProductId];
            trackEvent('diagtools', 'ecommerce', 'product click', 'product click', eventObj);
            trackAddtoBagPage(quizProductId);
          });
        }

        function trackAddtoBagPage(productId) {
          var objView = {
            enh_action: 'detail',
            product_id: [productId]
          };
          site.track.evtView(objView);
        }

        function trackNextPage(pageurl, plocation, pname) {
          var objView = {};
          Object.assign(objView, {
            page_url: pageurl,
            location: location.origin + location.pathname + plocation,
            page_name: pname
          });
          site.track.evtView(objView);
          objView = {};
        }

        function initSkinDiagnosticTagging() {
          foundationstartTagging();
          trackNavTagging();
          trackBackButton();
          resultPageTagging();
          trackRequiz();
          trackProductClick();
          trackQuickShop();
          trackAddtoBagPage();
        }
      }
      // Skincare Diagnostic Quiz Tagging end.

      // EL Foundation finder start.
      if ($('body').hasClass('section-foundation-finder')) {
        trackEsteeFinderTagging();
      }

      function trackEsteeFinderTagging() {
        initEsteeFinderTagging();

        function foundationNextTagging() {
          $(document).on('Next', function(event, data) {
            var quizNav = $('.js-foundation-finder--quiz__nav-item.expended').find('.foundation-finder--quiz__nav-label').text().trim();
            var quizNavSplit = quizNav.split(' ');
            var quizNavLabel = quizNavSplit[1];
            var quizNavValue = $('.js-foundation-finder--quiz__nav-item.expended').find('.js-foundation-finder--quiz__nav-value').text().trim();
            var quizQuestionKey = $('.js-foundation-finder--quiz-slide.slick-active .js-foundation-finder--quiz-question').data('question-key') || quizNavLabel;
            var quizAnswer = $('.js-foundation-finder--quiz-button--next').closest('.js-foundation-finder--quiz').find('.js-foundation-finder--quiz__carousel-wrapper .slick-active .js-foundation-finder--quiz-answer.selected-answer').data('translated-answer') || quizNavValue;
            var quizmobStepIndex = $('.js-foundation-finder--quiz__nav-item.expended').data('step-index') + 2;
            var stepIndex = $('.js-foundation-finder--quiz-slide.slick-active').data('question-index') + 2 || quizmobStepIndex;
            var eventLabel = quizQuestionKey + ' - ' + quizAnswer;
            var mobEventLabel = quizQuestionKey || quizNavLabel + ' - ' + quizAnswer || quizNavValue;
            if (quizAnswer) {
              trackEvent('diagtools', 'diagnostic tool - Foundation Finder', 'questions', eventLabel);
              if (stepIndex !== 6 && !$('div').hasClass('results-loaded')) {
                trackNextPage('/foundation-finder/step' + stepIndex, '/foundation-finder/step' + stepIndex, 'foundation-finder - Step ' + stepIndex);
              }
            }
          });
        }

        function trackbreadcrumTagging() {
          $(document).on('click', '.js-foundation-finder--quiz__nav-item', function() {
            var stepCount = $(this).data('step-index') + 1;
            if (!$(this).hasClass('disabled')) {
              trackNextPage('/foundation-finder/step' + stepCount, '/foundation-finder/step' + stepCount, 'foundation-finder - Step ' + stepCount);
            }
          });
        }

        function trackProductDetails() {
          $(document).on('click', '.ff-results__product .sku-brief-editorial__image-wrapper, .sku-brief-editorial .text-product-listing-names-main, .sku-brief-editorial .text-product-listing-names-sub, .sku-brief-editorial .product_brief__desc1', function() {
            var finderProductId = $(this).closest('.sku-brief-editorial').data('productid');
            var finderProductPosition = $(this).closest('.slick-slide').data('slick-index') + 1;
            var finderProductName = $(this).closest('.sku-brief-editorial').find('.text-product-listing-names-main').text().trim();
            var eventLable = finderProductName + '-' + finderProductId;
            var eventObj = {};
            eventObj.enh_action = 'product_click';
            eventObj.product_position = [finderProductPosition];
            eventObj.product_list = [location.pathname + '/results'];
            eventObj.product_id = [finderProductId];
            trackEvent('diagtools', 'ecommerce', 'product click', eventLable, eventObj);
          });
        }

        function trackAddToBag() {
          $(document).on('click', '.ff-results__product .js-add-to-cart', function() {
            var finderProductId = $(this).closest('.ff-results__product').data('productid');
            var finderProductPosition = $(this).closest('.ff-results__product').data('slick-index') + 1;
            var eventObj = {};
            eventObj.enh_action = 'product_click';
            eventObj.product_position = [finderProductPosition];
            eventObj.product_list = [location.pathname + '/results'];
            eventObj.product_id = [finderProductId];
            trackEvent('diagtools', 'ecommerce', 'product click', 'product click', eventObj);
            trackAddtoBagPage(finderProductId);
          });
        }

        function resultPageTagging() {
          $(document).on('filterResult', function() {
            var $menuItems = $('.js-ff-results-recommended-products');
            var $recommendedItems = $('.spp__steps');
            var productImpressionIds = [];
            var productPositions = [];
            var productImpressionList = [];
            var $elem;
            $menuItems.find('.ff-results__product').each(function(index, elem) {
              if (!$(elem).length) {
                return;
              }
              $elem = $(elem);
              productImpressionIds.push($elem.attr('data-productid'));
              productPositions.push(index + 1);
              productImpressionList.push(location.pathname + '/results');
            });

            $recommendedItems.find('.quickshop__add-button').each(function(index, elem) {
              if (!$(elem).length) {
                return;
              }
              $elem = $(elem);
              productImpressionIds.push($elem.attr('data-productid'));
              productPositions.push(index + 1);
              productImpressionList.push(location.pathname + '/also_recommended');
            });
            var objView = {
              product_impression_list: productImpressionList,
              product_impression_position: productPositions,
              product_impression_id: productImpressionIds,
              location: location.origin + location.pathname + '/results',
              page_url: '/foundation-finder/result',
              page_name: 'foundation-finder - result'
            };
            site.track.evtView(objView);
          });
        }

        function trackRequiz() {
          $(document).on('click', '.js-foundation-finder--quiz__start-over, .js-launch-account--return', function() {
            var eventLable = $(this).text().trim();
            trackEvent('diagtools', 'diagnostic tool - Foundation Finder', eventLable, 'Click');
            if ($(this).hasClass('js-foundation-finder--quiz__start-over')) {
              trackNextPage('/foundation-finder/step1', '/foundation-finder/step1', 'foundation-finder - Step 1');
            }
          });
        }

        function trackSaveProfileRequiz() {
          $(document).on('touchend', '.ff-results__link-item .js-launch-account--return', function() {
            var eventLable = $(this).text().trim();
            trackEvent('diagtools', 'diagnostic tool - Foundation Finder', eventLable, 'Click');
          });
        }

        function trackNextPage(pageurl, plocation, pname) {
          var objView = {};
          Object.assign(objView, {
            page_url: pageurl,
            location: location.origin + plocation,
            page_name: pname
          });
          site.track.evtView(objView);
          objView = {};
        }

        function trackAddtoBagPage(productId) {
          var objView = {
            enh_action: 'detail',
            product_id: [productId]
          };
          site.track.evtView(objView);
        }

        function initEsteeFinderTagging() {
          foundationNextTagging();
          trackbreadcrumTagging();
          resultPageTagging();
          trackProductDetails();
          trackRequiz();
          trackSaveProfileRequiz();
          trackAddToBag();
        }
      }
      // EL Foundation finder end.

      // Blog page Tagging start.
      if ($('body').hasClass('section-discover') || $('div').hasClass('js-discover-article')) {
        $(document).on('click', '.js-discover-navigation ul li a', function () {
          var eventLabel = $(this).text().trim();

          trackEvent('blog', 'blog', 'blog category selection', eventLabel);
        });

        $(document).on('click', '.js-discover-block__container', function () {
          var $blogImageElem = $(this);
          var eventLabel = $blogImageElem.find('.discover-block__url').attr('href');
          var blogSubtitle = $blogImageElem.find('.discover-block__teaser').text().trim();
          var blogDiscription = blogSubtitle.split(' ');

          eventObj.content_title = $blogImageElem.find('.discover-block__header').text().trim();
          eventObj.content_author = 'null';
          eventObj.content_category = 'null';
          eventObj.content_subcategory = 'null';
          eventObj.content_word_count = blogDiscription.length;
          trackEvent('blog', 'blog', 'blog category selection', eventLabel, eventObj);
        });

        window.onload = function () {
          if ($('div').hasClass('js-product-brief-carousel-items')) {
            var $menuItems = $('.slick-list');
            var productImpressionIds = [];
            var productPositions = [];
            var $elem;

            $menuItems.find('.slick-slide').each(function (index, elem) {
              if (!$(elem).length) {
                return;
              }
              $elem = $(elem);
              productImpressionIds.push($elem.find('.mpp__product').attr('data-product-id'));
              productPositions.push(index);
            });

            var objView = {
              product_impression_list: ['/blog list'],
              product_impression_position: productPositions,
              product_impression_id: productImpressionIds,
              location: window.location.href
            };

            site.track.evtView(objView);
          }
        };

        $(document).on('click', '.js-product-brief', function () {
          var $blogImageElem = $(this);
          var blogResultId = $blogImageElem.data('product-id');
          var blogProdPosition = parseInt($blogImageElem.closest('.slick-slide').attr('data-slick-index'));

          eventObj.enh_action = 'product_click';
          eventObj.product_position = [blogProdPosition];
          eventObj.product_list = ['blog list'];
          eventObj.product_id = ['PROD' + blogResultId];
          trackEvent('blog', 'ecommerce', 'product click', 'product click', eventObj);
        });

        $(document).on('click', '.js-discover-block__subtags a', function () {
          var eventLabel = $(this).attr('href');

          trackEvent('blog', 'blog', 'blog - link click', eventLabel);
        });

        $('.js-blog-article__social-share ul li a').on('click', function () {
          var eventLabel = $(this).closest('li').attr('class');

          trackEvent('social share', 'social', 'share - blog page', eventLabel);
        });
      }
      // Blog page Tagging end.

      // Event track common function call start
      function trackEvent(eName, eCategory, eAction, elabel, eventObj) {
        eventObj = eventObj || {};
        Object.assign(eventObj, {
          event_name: eName,
          event_category: eCategory,
          event_action: eAction,
          event_label: elabel
        });
        site.track.evtLink(eventObj);
      }
      // Event track common function call end.

      document.addEventListener(
        'click',
        function (e) {
          const checkbox = e.target.closest('.elc-checkbox');

          if (!checkbox) {
            return;
          }

          const eventLabel = checkbox.querySelector('.js-checkbox-label')?.textContent.trim() || '';

          trackEvent('filters_and_sort_selection', 'filter & sort selection', 'sort - MPP', eventLabel);
        },
        true
      );

      self.attached = 1;
    }
  };
}(window.site || {}, jQuery));